<script setup lang="ts">
import FilteringDataDisplay from '../FilteringDataDisplay.vue'
import { useStoreProfiles } from '../../store/useStoreProfiles'
import { computed, ref, shallowRef, watchEffect } from 'vue'
import { useFilteringDisplayOptions } from '../../composables/useFilteringDisplayOptions'
import { useOrders } from '../../store/useOrders'
import FormOrderItem from '../FormOrderItem.vue'
import { Table } from 'app/types/components/data-rendering'
const props = defineProps<{
  storeId: string | number
  isFetching: boolean
}>()
//picklist
const loading = ref(true)
const pickListData = shallowRef<Table>({ data: [], meta: { columns: {} } })

watchEffect(
  async () => {
    //tasks
    const { getPickListData } = useStoreProfiles()
    pickListData.value = getPickListData(props.storeId)
    loading.value = false
  },
  { flush: 'post' }
)
const pickListReasonCodes = [
  { name: 'neverReceivedOriginal' },
  { name: 'receivedPartialShipment' },
  { name: 'receivedIncorrectMaterials' },
  { name: 'materialsReceivedDamaged' },
  { name: 'other' },
]
const { pickListDisplayOptions, pickListClickedRow, openOrderModal } = useFilteringDisplayOptions({
  isFetching: props.isFetching,
})
const ordersHeaders = computed((): { header: string; subheaders: [string, string] } => {
  return {
    header: 'Add Item to Order',
    subheaders: [pickListClickedRow.value?.artwork_id, pickListClickedRow.value?.description],
  }
})
//todo move order modal to wrapper component
const { addOrder } = useOrders()
const addOrderItem = (e: any) => {
  addOrder({
    artwork_id: e.data.artwork_id,
    quantity: e.quantity,
    reason: e.reason,
    comment: e.comment,
    date: e.date,
  })
}
</script>
<template>
  <q-dialog v-model="openOrderModal">
    <FormOrderItem
      :headers="ordersHeaders"
      :data="pickListClickedRow"
      :reason-options="pickListReasonCodes"
      @action="addOrderItem"
      :render-order="['quantity', 'reason', 'comment']"
      v-if="pickListClickedRow"
    />
  </q-dialog>
  <FilteringDataDisplay
    :key="`${storeId}-${loading}-picklist`"
    :is-loading="loading"
    :table-data="pickListData"
    :options="pickListDisplayOptions"
    :enable-filters="true"
  />
</template>
